module.exports = __webpack_public_path__ + "media/public/fonts/QanelasSemiBold/QanelasSemiBold-41f34a1e2a8aae6a3d62c9673205eb8b.svg";